import Temp from '@/courier/Temp'
export default class MakesendExpressChilled extends Temp {

    static CODE = 'MSEC';

    constructor() {
        super( MakesendExpressChilled.CODE ); 
    }

    getZone( item ) {
        let type , from , to
        let cross_price = 0
        let remote_area = 0

        remote_area = super.checkRemoteArea( Number(item.toPostcode) );
        
        from = super.checkZone( item.fromPostcode )
        to = super.checkZone( item.toPostcode )
        // "BKK" = 1
        // "GBKK" = 2
        // "NPT" = 3
        // "SKM" = 4
        // "SKN" = 5
        // "HUAHIN" = 6
        // "CBI" = 7
        // "PBI" = 8
        // "RBR" = 9
        // "KKN" = 10
        // "NMA" = 11 // นครราชศรีมา
        // "NRT" = 12 // นครศรีธรรมราช
        if ([1,2].includes(from) && to == 1) {
          type = 1;
        } else if ([1,2].includes(from) && to == 2) {
          type = 2;
        } else if ([1,2].includes(from) && [7, 9, 8, 6, 4, 11].includes(to)) {
          type = 3;
        } else if (from == 7 && to == 7) {
          type = 4;
        } else if (from == 7 && [1,2].includes(to)) {
          type = 5;
        } else if ([8, 6, 4, 9].includes(from) && [8, 6, 4, 9].includes(to)) {
          if (from == to) {
            type = 6
          } else {
            type = 7;
          }
        } else if ([8, 6, 4, 9].includes(from) && [1,2].includes(to)) {
          type = 8;
        } else if ([10,12].includes(from) && [10,12].includes(to) && from == to){
          type = 9
        } else if (from == 11 && to == 11) {
          type = 10
        } else if (from == 11 && [1,2].includes(to)) {  
          type =11
        } else {
          type = -1
        }

        return {
            rate_type : type ,
            rate_remote_area : remote_area ,
            cross_price : cross_price
        }
    }
    checkWeight( courierRates, item ) {
      item.index = courierRates.findIndex(rate => {
          return item.weight >= rate.min && item.weight <= rate.max
      })

      return {
          index: item.index
      } 
    }
    checkDimension( dimensionCourier , item , validate ){
      return super.checkCourierDimension( dimensionCourier , item , validate );
    }
    async checkRemoteAreaByCorrectorDest( addressRemote ){
      return new Promise(resolve => {
        super.getRemoteArea( addressRemote ).then( res => {
          if( res.status === 1 && ((res.data).hasOwnProperty('isRemote') 
              || (res.data).hasOwnProperty('isRemote100') )
              && res.data.isRemote.includes('mse') 
              || ( (res.data).hasOwnProperty('isIsland') && res.data.isIsland.includes('mse') )
          ){
            resolve( true );
          }else if( res.status === 0 && res.data.length === 0 ){
            resolve( true );
          }else{
            resolve( false );
          }
        }) 
      })
    }

}